import { createApp } from '@steinpilz/react-ux';
import { appConfig } from '@configs/app';

import App from './application';

async function main() {
  const app = await createApp(appConfig);

  app.render(<App />);
}

main();
